import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { GalaxyButtonGroupModule } from '@vendasta/galaxy/button-group';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

import { EmailViewerComponent } from './email-viewer.component';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
export { EmailViewerComponent };

export const MODULE_IMPORTS = [
  CommonModule,
  MatIconModule,
  GalaxyButtonGroupModule,
  GalaxyPipesModule,
  MatButtonModule,
];

export const MODULE_DECLARATIONS = [EmailViewerComponent];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: [MODULE_IMPORTS, GalaxyLoadingSpinnerModule],
  exports: [EmailViewerComponent],
})
export class GalaxyEmailViewerModule {}
